import React, { View, Image, TouchableOpacity } from 'react-native';
import { Dispatch, SetStateAction } from 'react';
import { Hoverable } from 'react-native-web-hover';
import { faSearchPlus, faTrash, faAdd } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import Toast from 'react-native-toast-message';
import { translate } from '../../../services/translate';
import { Tabs } from '../../../components/Tabs';


interface PersonFormPicturesParams {
    facePictures: FacialFacePicture[];
    setImageZoom: (facialFacePicture: FacialFacePicture) => void;
    setFacePictureToDelete: (facialFacePicture: FacialFacePicture) => void;
    setDeleteFacePictureModalVisible: (visible: boolean) => void;
    files: { file: File; objectURI: string; key: string; }[];
    setFiles: Dispatch<SetStateAction<{
        file: File;
        objectURI: string;
        key: string;
    }[]>>;
    isSspWantedPerson: boolean;
}

function RegisteredPhotos({
    facePictures,
    setImageZoom,
    setFacePictureToDelete,
    setDeleteFacePictureModalVisible,
    files,
    setFiles,
    isSspWantedPerson,
}: PersonFormPicturesParams) {
    const { styles, theme } = useStyles(stylesheet);

    return <View style={styles.content}>
        {facePictures.filter(fp => fp.deletedAt === null).map((facePicture) =>
            <View key={facePicture.id.toString()} style={{ marginRight: 10 }}>
                <Hoverable>
                    {({ hovered }) => (<>
                        <Image
                            style={{
                                height: 136, width: 136,
                                borderRadius: 8,
                                overflow: 'hidden',
                            }}
                            source={{ uri: facePicture.imageUrl }}
                        />

                        {hovered &&
                            <View style={styles.hoveredContent}>
                                <TouchableOpacity
                                    style={styles.iconView}
                                    onPress={async () => {
                                        setImageZoom(facePicture);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faSearchPlus} fontSize={22} color={'#FFFFFF'} />
                                </TouchableOpacity>
                                {!isSspWantedPerson &&
                                    <TouchableOpacity
                                        style={styles.iconView}
                                        onPress={() => {
                                            setFacePictureToDelete(facePicture);
                                            setDeleteFacePictureModalVisible(true);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} fontSize={22} color={'#FFFFFF'} />
                                    </TouchableOpacity>
                                }
                            </View>
                        }

                    </>)}
                </Hoverable>

            </View>
        )}
        {files.map((img) =>

            <Image
                key={img.key}
                style={{
                    height: 136, width: 136,
                    borderRadius: 8,
                    overflow: 'hidden',
                    marginRight: 10
                }}
                source={{
                    uri: img.objectURI
                }}
            />

        )}
        {!isSspWantedPerson &&
            <Hoverable>
                {({ hovered }) => (
                    <TouchableOpacity style={{
                        height: 136,
                        width: 136,
                        borderRadius: 8,
                        overflow: 'hidden',
                        backgroundColor: hovered ? theme.colors.primaryButton.hoverBackground : theme.colors.primaryButton.background,
                        marginRight: 10,
                    }} >
                        <label style={{ width: '100%', height: '100%', display: 'grid' }}>
                            <input
                                style={{ display: 'none' }}
                                type='file'
                                onChange={(e) => {
                                    if (!e.target.files) {
                                        return;
                                    }
                                    const file = e.target.files[0];

                                    if (!['image/jpeg', 'image/png'].includes(file.type)) {
                                        return Toast.show({
                                            type: 'sentinelxError',
                                            text1: translate('imageFormatNotValid'),
                                        });
                                    }
                                    setFiles(current => [...current, { file, objectURI: URL.createObjectURL(file), key: String(Math.random()) }]);
                                }}
                                accept='image/jpeg,image/png'
                            />
                            <FontAwesomeIcon fontSize={30} icon={faAdd} color={theme.colors.container.background} style={{ justifySelf: 'center', alignSelf: 'center' }} />

                        </label>
                    </TouchableOpacity>
                )}
            </Hoverable>
        }
    </View>;
}

export default function PersonFormPictures({
    facePictures,
    setImageZoom,
    setFacePictureToDelete,
    setDeleteFacePictureModalVisible,
    files,
    setFiles,
    isSspWantedPerson,
}: PersonFormPicturesParams) {
    const { styles } = useStyles(stylesheet);

    return <> {facePictures.filter(fp => fp.deletedAt).length > 0 ? <Tabs tabs={[{
        key: 'photos',
        label: translate('photos')
    }, {
        key: 'historicPhotos',
        label: translate('historicPhotos')
    }]}>
        {({ selectedTab }) => {
            if (selectedTab == 'photos') {
                return <RegisteredPhotos
                    facePictures={facePictures}
                    files={files}
                    setDeleteFacePictureModalVisible={setDeleteFacePictureModalVisible}
                    setFacePictureToDelete={setFacePictureToDelete}
                    setFiles={setFiles}
                    setImageZoom={setImageZoom}
                    isSspWantedPerson={isSspWantedPerson}
                />;
            }
            if (selectedTab == 'historicPhotos') {
                return <View style={styles.content}>
                    {facePictures.filter(fp => fp.deletedAt).map((fp) =>

                        <Image
                            key={fp.id}
                            style={{
                                height: 136, width: 136,
                                borderRadius: 8,
                                overflow: 'hidden',
                                marginRight: 10
                            }}
                            source={{
                                uri: fp.imageUrl
                            }}
                        />

                    )}
                </View>;
            }
        }}
    </Tabs> : <RegisteredPhotos
        facePictures={facePictures}
        files={files}
        setDeleteFacePictureModalVisible={setDeleteFacePictureModalVisible}
        setFacePictureToDelete={setFacePictureToDelete}
        setFiles={setFiles}
        setImageZoom={setImageZoom}
        isSspWantedPerson={isSspWantedPerson}
    />
    }</>;
}


const stylesheet = createStyleSheet(() => ({
    content: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 0,
        alignItems: 'flex-start',
        flex: 1
    },
    hoveredContent: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: '#00000080',
        borderRadius: 8,
        flexDirection: 'row',
        gap: 15,
        alignItems: 'center',
        justifyContent: 'center',
    },
    iconView: {
        width: 40,
        height: 40,
        alignItems: 'center',
        justifyContent: 'center',
    }
}));
